import React, { useRef, useState } from "react";
import signUpImg from "../assets/signup.svg";
import PasswordField from "../component/PasswordField";
import InputFieldsWithIcon from "../component/InputFieldsWithIcon";
import ButtonCompo from "../component/ButtonCompo";
import logo from "../assets/companyLogo.png";
import welcomeImg from "../assets/welcome.png";
import { useForm } from "react-hook-form";
import AlertBox from "../component/AlertBox";
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance, passwordRegex } from "../constant";
import Loading from "../component/Loading";
import { useDispatch } from "react-redux";
import { login } from "../store/auth.slice";
import DialogBox from "../component/DialogBox";

function Signin() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(undefined);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const alertRef = useRef(null);

  const handleAlertOpen = () => {
    if (alertRef.current) {
      alertRef.current.handleOpen();
    }
  };

  async function createAccount(data) {
    try {
      setLoading(true);
      const res = await axiosInstance.post("/api/v1/user/login", data);
      dispatch(login({ status: true }));
      navigate("/");
    } catch (error) {
      // setOpen(true);
      // setSuccess(false);
      // setMessage(error?.response?.data?.message);
      handleAlertOpen();
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <Loading />}
      <DialogBox
        ref={alertRef}
        actionButton={<ButtonCompo href="/signup">Okay</ButtonCompo>}
      >
        <div className="w-full flex justify-center items-center flex-col">
          <img src={welcomeImg} className="w-[20rem]" alt="" />
          <p className="text-slate-600">
            We have come with a new version of{" "}
            <span className="font-semibold text-[#FF8000]">
              Nutribiosciences
            </span>{" "}
            to improve your user experience. Please create your new account to
            continue with us.
          </p>
        </div>
      </DialogBox>
      <div className="w-full flex justify-center items-center h-[100vh] bg-[#FFEDD0] flex-col">
        {success !== undefined && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[30rem] h-[30rem] top-[-10rem] z-[1] right-[-10rem] bg-[#FFDB57]/40 fixed rounded-full blur-[10rem]"></div>
        <div className="w-[30rem] h-[30rem] top-[-10rem] z-[1] right-[-10rem] bg-[#FF8000]/20 fixed rounded-full blur-[10rem]"></div>
        <div className="w-full h-full flex justify-center items-center place-items-center gap-3">
          <div className="w-1/2 h-full text-center hidden md:flex justify-center flex-col items-center gradient-custom">
            <h2 className="heading_text text-[40px] text-white translate-x-[-100%] animate-slide-in uppercase font-medium">
              Welcome to
            </h2>
            <h1 className="heading_text text-[50px] font-bold uppercase text-white translate-x-[-100%] animate-slide-out">
              Nutribiosciences
            </h1>
            <p className="heading_text text-[25px] mb-[3rem] w-[40rem] text-white translate-x-[-100%] animate-slide-top">
              "Nutri Bio Science offers natural, plant-based healthcare products
              crafted to enhance lifestyle.
            </p>
            <img
              src={signUpImg}
              className="w-[25rem] translate-x-[-100%] animate-slide-bottom"
              alt=""
            />
          </div>
          <div className="w-1/2 flex items-center justify-center h-full flex-col gap-[2rem] lg:gap-[5rem] z-[10]">
            <div className="w-[95vw] md:w-[25rem]">
              <div className="flex w-full justify-center items-center mb-3">
                <img src={logo} className="w-[10rem]" alt="" />
              </div>
              <h1 className="text-center text-[30px] md:text-[40px] font-semibold text-[#965311]">
                Log In
              </h1>
              <p className="text-center text-orange-800/60 mt-2">
                Please log in to your account
              </p>
              <form className="w-full" onSubmit={handleSubmit(createAccount)}>
                <div className="mt-[3rem] space-y-3">
                  <InputFieldsWithIcon
                    label={"Phone"}
                    {...register("phone", {
                      required: {
                        value: true,
                        message: "This field is required.",
                      },
                    })}
                    error={errors?.email}
                  />
                  <PasswordField
                    {...register("password", {
                      required: {
                        value: true,
                        message: "This field is required.",
                      },
                    })}
                    error={errors?.password}
                  />
                </div>
                <ButtonCompo
                  type="submit"
                  className="!w-full !h-[3rem] !bg-orange-500 !mt-7 !text-white !font-bold"
                >
                  log in
                </ButtonCompo>
              </form>
              <p className="mt-5 text-slate-500 text-center text-[15px]">
                Don't have an account?{" "}
                <Link
                  className="font-medium underline text-[#965311]"
                  to={"/signup"}
                >
                  Create An Account
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signin;
